import { SettingsCard, SettingsOptionList, SettingsOptionRow } from '@vyce/core/src/components/SettingsCard';

interface Props {
  countAutoClockOut: boolean;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  updatePreferences: (countAutoClockOut: boolean) => void;
}

export const AutomaticClockOut = ({
  countAutoClockOut,
  expanded,
  onExpandedChange,
  updatePreferences,
}: Props) => (
  <SettingsCard
    title="Forgotten clock outs"
    description="If someone clocks in but never clocks out, Vyce closes the day for them at 23:59. Choose what that day gets paid."
    status={countAutoClockOut ? 'Paid as normal shift' : 'Paid as zero hours'}
    expanded={expanded}
    onExpandedChange={onExpandedChange}
  >
    <SettingsOptionList>
      <SettingsOptionRow
        label="Pay zero hours"
        hint="Nothing is paid until a manager adds the real hours. Best for strict time governance."
        selected={!countAutoClockOut}
        onSelect={() => updatePreferences(false)}
      />

      <SettingsOptionRow
        label="Pay their normal shift"
        hint="The day is paid as if they worked their scheduled shift."
        selected={countAutoClockOut}
        onSelect={() => updatePreferences(true)}
      />
    </SettingsOptionList>
  </SettingsCard>
);
